/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import Constants from '../../Config/Config';

class MetaData extends Component {
  render() {
    return (
      <div className="frame-spec-list">
        <div className="frame-spec-item"><strong>Profile:</strong> {this.props.selectedFrame.get('name')}</div>
        {this.props.selectedFrame.getIn(['dimensions', 'height']) !== undefined && <div className="frame-spec-item"><strong>Height:</strong> {this.props.selectedFrame.getIn(['dimensions', 'height'])}cm</div>}
        {this.props.selectedFrame.getIn(['dimensions', 'width']) !== undefined && <div className="frame-spec-item"><strong>Width:</strong> {this.props.selectedFrame.getIn(['dimensions', 'width'])}cm</div>}
        {this.props.selectedFrame.get('frame_color') && <div className="frame-spec-item"><strong>Color:</strong> {this.props.selectedFrame.get('frame_color')}</div>}
        {this.props.selectedFrame.get('frame_material') && <div className="frame-spec-item"><strong>Material:</strong> {this.props.selectedFrame.get('frame_material')}</div>}
        {this.props.selectedFrame.get('frame_finish') && <div className="frame-spec-item"><strong>Finish:</strong> {this.props.selectedFrame.get('frame_finish')}</div>}
        {this.props.selectedFrame.get('frame_style') && <div className="frame-spec-item"><strong>Style:</strong> {this.props.selectedFrame.get('frame_style')}</div>}
        <div className="frame-spec-item"><strong>Price:</strong> {Constants.Currency + this.props.frameTotal}</div>
      </div>
    );
  }
}
export default MetaData;